import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
var _excluded = ["xs", "sm", "md", "lg", "xl", "xxl", "order", "orderSm", "orderMd", "orderLg", "orderXl", "orderXxl", "children", "className", "as"];
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import grid from "@xo-union/tk-css-grid/lib/styles.css";

var getGridSizeClasses = function getGridSizeClasses(breakpoints) {
  var _context;

  return _reduceInstanceProperty(_context = _Object$keys(breakpoints)).call(_context, function (classes, key) {
    var _context2;

    if (!breakpoints[key]) {
      return classes;
    }

    var sizeSuffix = breakpoints[key] === true ? '' : "-".concat(breakpoints[key]);
    var breakpointInfix = key === 'xs' ? '' : "-".concat(key);
    return cx(classes, grid[_concatInstanceProperty(_context2 = "col".concat(breakpointInfix)).call(_context2, sizeSuffix)]);
  }, '');
};

var getGridOrderClass = function getGridOrderClass(orderBreakpoints) {
  var _context3;

  return _reduceInstanceProperty(_context3 = _Object$keys(orderBreakpoints)).call(_context3, function (classes, key) {
    var _context4;

    if (!orderBreakpoints[key]) {
      return classes;
    }

    var _key$match = key.match(/order(..)?$/),
        _key$match2 = _slicedToArray(_key$match, 2),
        breakpoint = _key$match2[1];

    var breakpointInfix = breakpoint ? "-".concat(breakpoint.toLowerCase()) : '';
    var valueSuffix = "-".concat(orderBreakpoints[key]);
    return cx(classes, grid[_concatInstanceProperty(_context4 = "order".concat(breakpointInfix)).call(_context4, valueSuffix)]);
  }, '');
};

var Column = function Column(_ref) {
  var xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl,
      xxl = _ref.xxl,
      order = _ref.order,
      orderSm = _ref.orderSm,
      orderMd = _ref.orderMd,
      orderLg = _ref.orderLg,
      orderXl = _ref.orderXl,
      orderXxl = _ref.orderXxl,
      children = _ref.children,
      className = _ref.className,
      ComponentToRender = _ref.as,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = [getGridOrderClass({
    order: order,
    orderSm: orderSm,
    orderMd: orderMd,
    orderLg: orderLg,
    orderXl: orderXl,
    orderXxl: orderXxl
  }), getGridSizeClasses({
    xs: xs,
    sm: sm,
    md: md,
    lg: lg,
    xl: xl,
    xxl: xxl
  }), className];
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    className: cx(classes)
  }, props), children);
};

var allowedColumnValues = process.env.NODE_ENV !== "production" ? ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'] : {};
var columnNumberPropType = process.env.NODE_ENV !== "production" ? PropTypes.oneOf(allowedColumnValues) : {};
var allowedColumnSizeProps = process.env.NODE_ENV !== "production" ? _concatInstanceProperty(allowedColumnValues).call(allowedColumnValues, [true, 'auto']) : {};
var columnSizePropType = process.env.NODE_ENV !== "production" ? PropTypes.oneOf(allowedColumnSizeProps) : {};
process.env.NODE_ENV !== "production" ? Column.propTypes = {
  /**
   * Component to render
   */
  as: PropTypes.elementType,
  xs: columnSizePropType,
  sm: columnSizePropType,
  md: columnSizePropType,
  lg: columnSizePropType,
  xl: columnSizePropType,
  xxl: columnSizePropType,
  order: columnNumberPropType,
  orderSm: columnNumberPropType,
  orderMd: columnNumberPropType,
  orderLg: columnNumberPropType,
  orderXl: columnNumberPropType,
  orderXxl: columnNumberPropType,
  children: PropTypes.node,
  className: PropTypes.string
} : void 0;
Column.defaultProps = {
  className: '',
  as: 'div'
};
export default Column;